import { z } from 'zod';

const baseTaskSchema = z.object({
  description: z.string().min(1, 'Description is required'),
  dueAt: z
    .date({
      required_error: 'Due date is required',
      invalid_type_error: 'Due date is required',
    })
    .refine(
      (date) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return date >= today;
      },
      { message: 'Due date must be after today' }
    ),
  typeId: z.number().optional(),
  matterId: z.number({ required_error: 'Matter is required', invalid_type_error: 'Matter is required' }),
  assignedStaffId: z.number().optional(),
  clientId: z.number().optional(), // Used for filtering matters, not sent to API
});

export type TaskFormValues = z.infer<typeof baseTaskSchema>;

export function createTaskSchema(isStaff: boolean) {
  return baseTaskSchema.extend({
    assignedStaffId: isStaff
      ? z.number().optional()
      : z.number({ required_error: 'Assigned staff is required', invalid_type_error: 'Assigned staff is required' }),
  });
}

export const taskSchema = createTaskSchema(false);

export const taskTypeSchema = z.object({
  name: z.string().min(1, 'Name is required'),
});

export type TaskTypeFormValues = z.infer<typeof taskTypeSchema>;
